module.exports = __webpack_public_path__ + "img/product-placeholder-66.1000623.png";